import React, { useEffect, useState, useContext, useRef } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import GlobalState from "contexts/GlobalState"
import { Col, Row, CardBody } from "reactstrap"
import { Link } from "react-router-dom"
import ApexCharts from "apexcharts"
import ReactApexChart from "react-apexcharts"

// Locale/weekday related imports
import fi from "apexcharts/dist/locales/fi.json"
import se from "apexcharts/dist/locales/se.json"
import en from "apexcharts/dist/locales/en.json"

const BedChartTest = props => {
  const [state] = useContext(GlobalState)
  const [language, setLanguage] = useState("fi")
  const [series, setSeries] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  // Chart data changed
  useEffect(() => {
    setIsLoading(true)
    if (props.data) {

      let activity = props.data.map(item => [item.date, item.activity])
      let bed = props.data.map(item => [item.date, item.bed])

      // Bed, Kasvatetaan diagrammissa näytettävää käyttömäärää
      const renderedBedValue = 40
      const bedData = (bed ?? []).map(([x, y]) => [
        x,
        y > 0 ? renderedBedValue : y,
      ])

      // Set series
      setSeries([
        {
          name: props.t("Bed"),
          value: props.t("Bed"),
          data: bedData,
          type: "area",
        },
        {
          name: props.t("Bed movement"),
          value: props.t("Bed movement"),
          data: activity,
          type: "area",
        },
      ])
    }
    setIsLoading(false)
  }, [props.data])

  // Init language
  useEffect(() => {
    const currentLanguage = localStorage.getItem("i18nextLng")
    if (currentLanguage) {
      if (currentLanguage.startsWith("fi")) {
        setLanguage("fi")
      } else if (currentLanguage.startsWith("sv")) {
        setLanguage("se")
      } else {
        setLanguage("en")
      }
    }
  }, [])

  // Language change
  useEffect(() => {
    switch (state.language) {
      case "fi":
        setLanguage("fi")
        ApexCharts.exec("small-chart", "setLocale", "fi")
        break
      case "en":
        setLanguage("en")
        ApexCharts.exec("small-chart", "setLocale", "en")
        break
      case "sv":
        setLanguage("se")
        ApexCharts.exec("small-chart", "setLocale", "se")
        break
    }
  }, [state.language])

  // Toolbar
  const settingToolbar = t => {
    //const isHome = t === "home"
    return {
      show: true, // isHome
      offsetX: 0,
      offsetY: 0,
      tools: {
        download: true,
        selection: true,
        zoom: true,
        zoomin: true,
        zoomout: true,
        pan: true,
        reset: true,
        customIcons: [],
      },
      export: {
        csv: {
          filename: undefined,
          columnDelimiter: " ",
          headerCategory: "category",
          headerValue: "value",
          dateFormatter(timestamp) {
            return new Date(timestamp).toDateString()
          },
        },
        svg: {
          filename: undefined,
        },
        png: {
          filename: undefined,
        },
      },
      autoSelected: "zoom",
    }
  }

  // Options
  const [options] = useState({
    chart: {
      id: "small-chart",
      locales: [fi, en, se],
      defaultLocale: language,
      toolbar: settingToolbar(),
      stacked: false,
    },
    dataLabels: { enabled: !1 },
    // Bed, activity
    stroke: { curve: "smooth", width: [2, 2] },

    // plotOptions: {
    //   bar: {
    //     columnWidth: "50%",
    //   },
    // },
    markers: {
      // Bed, activity
      size: [5, 5],
      colors: props.isDark ? [
        "#a6a6a600", // Bed
        "#48d0f800", // Activity
      ] : [
        "#a6a6a600", // Bed
        "#48d0f800", // Activity
      ],
      strokeWidth: 1,
      strokeOpacity: props.isDark ? 0.4 : 0.9,
      strokeColors: props.isDark ? [
        "#a6a6a600", // Bed
        "#48d0f800", // Activity
      ] : [
        "#a6a6a600", // Bed
        "#48d0f800", // Activity
      ],
      // https://htmlcolorcodes.com/color-chart/
    },
    xaxis: {
      type: "datetime",
      labels: {
        datetimeUTC: false,
      },
    },
    legend: {
      show: true,
      offsetY: 10,
      markers: {
        offsetX: -2,
      },
      itemMargin: {
        horizontal: 6
      },
    },
    tooltip: {
      followCursor: true,
      shared: false,
      intersect: true,
      x: {
        format: "dd.MM.yyyy HH:mm",
      },
    },
    //
    colors: props.isDark ? [
      "#a6a6a688", // Bed
      "#b23232ff", // Activity
    ] : [
      "#a6a6a688", // Bed
      "#f84848ff", // Activity
    ],
    fill: {
      // no effect in scatters
      opacity: [1, 1, 1, 1, 1, 1, 1],
      // bed, coffee, activity, wc, outsideDoor, micro, fridge
      type: ["solid", "solid", "gradient", "solid", "solid", "solid", "solid"],
      gradient: {
        type: "vertical",
        shade: props.isDark ? "dark" : "light",
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: props.isDark ? 1 : 0.75,
        stops: [0, 90, 100],
      },
      // solid: {
      //   color: "#ff9b00",
      //   width: 32,
      //   height: 32,
      // },
    },
  })

  return (
    <div>
      {isLoading ? (
        <Row>
          <Col xs="12">
            <CardBody className="text-center" style={{ height: props.size }}>
              <div className="py-5">
                <Link to="#" className="text-primary">
                  <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
                  {props.t("Loading")}
                </Link>
              </div>
            </CardBody>
          </Col>
        </Row>
      ) : (
        <ReactApexChart
          options={options}
          series={series}
          type="line"
          height={props.size}
        />
      )}
    </div>
  )
}

BedChartTest.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
  size: PropTypes.number,
  isDark: PropTypes.bool,
}

export default withTranslation()(BedChartTest)
